import { createI18n } from 'vue-i18n'
import messages from './languages'

export default createI18n({
  legacy: false,  // Use the Composition API syntax
  locale: 'de',   // Default language
  messages,       // Translations (from languages/index.ts)
}) 